module.exports = __webpack_public_path__ + "static/media/audition-img-large.ea88a45c.png";